import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LandingPage, MentionsLegales, PolitiqueConfidentialite } from '@/components/pages';

/**
 * Main App Component - Domain For Sale Landing Page
 */
const App: React.FC = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<LandingPage />} />
                <Route path="/mentions-legales" element={<MentionsLegales />} />
                <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
            </Routes>
        </BrowserRouter>
    );
};

export default App;